import type { ComponentType } from 'react'
import type { LucideProps } from 'lucide-react'

/**
 * Prime's mark: a four-point star standing on the horizon. One colour
 * (currentColor), no gradient, no shadow; the star is solid so it holds at 16px,
 * the horizon is a hairline that follows `strokeWidth` like the line icons do.
 * It takes the props of a lucide icon, so it drops in wherever one is used
 * (`NavItem.Icon`). Prime's mark is this and nothing else: no Bot, no Sparkles
 * (which is Agents) and no ✦ (which is Everything).
 */
export const PRIME_PATH = 'M12 2.5Q13 8.5 19 10Q13 11.5 12 17.5Q11 11.5 5 10Q11 8.5 12 2.5Z'

export const PrimeMark: ComponentType<LucideProps> = ({
  size = 24,
  strokeWidth = 1.75,
  color,
  absoluteStrokeWidth: _abs,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? 'currentColor'}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    data-prime-mark
    {...rest}
  >
    <path d={PRIME_PATH} fill="currentColor" />
    <path d="M4 21H20" />
  </svg>
)

/**
 * The mark on its own tile (the DevOS centre button, the sidebar): Prime's
 * colours in every appearance but black and glass, which draw it monochrome
 * like everything else there (`--prime-mark-*` in index.css).
 */
export const PrimeTile = ({ size, className }: { size: number; className?: string }) => (
  <span
    className={className}
    style={{ background: 'var(--prime-mark-bg)', color: 'var(--prime-mark-fg)' }}
    aria-hidden
  >
    <PrimeMark size={size} />
  </span>
)
